import { Component } from 'react';
import ReactDOM from 'react-dom';

/**
 * Portal Component to allow for appending an element to the dom body.  Useful for Modals and Popups.
 */
class Portal extends Component
{
	constructor(props){
		super(props);
		this.el = document.createElement('div');
	}

	componentDidMount() {
		document.body.appendChild(this.el);
	}

	componentWillUnmount(){
		document.body.removeChild(this.el);
	}

	render(){
		return ReactDOM.createPortal(
			this.props.children,
			this.el
		);
	}
}

export default Portal;